import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Header from '../master_root/header';
//page links  
export default function Creativeportfolios() {
  return (
       <div >
         <Header /> 
       <div className='app_header_height'></div>
    <div className="container_roots">
    <Helmet>
  <title>Creative Portfolios - Showcase Your Work | EditorTask</title>

  <meta name="description" content="Discover top creative portfolios on EditorTask. Browse work from editors, designers, video creators, writers, and more. Showcase your talent and get hired!" />
  <meta name="keywords" content="creative portfolios, showcase work, editor portfolios, designer portfolios, video editor portfolio, freelance portfolios, hire creative talent, EditorTask" />
  <meta name="author" content="EditorTask.com" />
  <meta name="robots" content="index, follow" />

  <meta property="og:title" content="Creative Portfolios - Discover Top Talent | EditorTask" />
  <meta property="og:description" content="Explore portfolios from talented editors, designers, and creators on EditorTask. Find the right talent for your projects." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.editortask.com/creative-portfolios" />
  <meta property="og:image" content="https://www.editortask.com/images/editortask_og_banner.png" />

  <link rel="canonical" href="https://www.editortask.com/creative-portfolios" />
</Helmet>

      <div className="container_size">
      <h2>Explore Creative Portfolios and Discover Talented Professionals</h2>
      <p>Find the best editors, designers, writers, and creators through their portfolios on EditorTask. Showcase your skills, get noticed, and connect with clients looking for creative excellence. Build your profile and stand out in the freelance market today!</p>
      </div>
</div>
</div>
    );
}
